module.exports = {"label":"AuthInfo","generationHint":"Click icon to generate"}